import React from 'react';
import { useTranslation } from 'react-i18next';

import '../styles/componentStyles/ColourBars.css';

const colors = [
  '#ef575a',
  '#f0605a',
  '#f26e59',
  '#f47f59',
  '#f79858',

  '#fca655',
  '#fcb354',
  '#fcbf54',
  '#fcc854',
  '#eec959',

  '#cfc966',
  '#d0c966',
  '#a7c776',
  '#83c285',
  '#65bf91',
];

function ColourBars(props) {
  const { t } = useTranslation();
  const titleId = props.title?.replace(/\s+/g, '');

  return (
    <div
      className={`chart-container ${props.width}`}
      role="group"
      aria-labelledby={`${titleId}-colour-bars-title`}
    >
      <div className="title-container">
        <h3 className="title" id={`${titleId}-colour-bars-title`}>
          {props.title}
        </h3>
      </div>
      <div className="rainbow-box">
        <div className="rainbow-text">{props.text}</div>
        <div className="rainbow-bars-cont-wrapper fs-mask">
          <div className="rainbow-bars-cont fs-mask">
            {colors.map((color, index) => {
              if (index + 1 <= props.value * 3) {
                return (
                  <div
                    key={index}
                    className="rainbow-bars"
                    style={{ backgroundColor: `${color}` }}
                  />
                );
              }
              return (
                <div key={index} className="rainbow-bars" style={{ backgroundColor: '#ddcedb' }} />
              );
            })}
          </div>
          <p className="rainbow-text-value">{`${props.value} ${t('DW053')}`}</p>
        </div>
      </div>
    </div>
  );
}

export default ColourBars;
